import React from "react";
import "./document.css";

const Cancelation = () => {
  return <div className="policy-wrapper">
  <h1>Refund & Cancellation Policy</h1>
    <p>
      

    We are ready to give you the best
    <br/>
    <br/>
We understand that, sometimes, plans change. If you can no longer make it to the class, please email us in advance at helpmission1success@gmail.com. Refunds will be made as per the policies mentioned below. We strive to maintain the highest standards of quality and as with everything we do at Mission1Success, you get a 100% Satisfaction Guarantee.
<br/>
<br/>POLICY A
<br/>
<br/>
Policy A applies to all Mission1Success courses under the categories of Digital Marketing , Data Science, Python
Cancellations prior to the course
<br/>
<br/>
In case you’re unable to attend the course and want a refund prior to the course commencement date, we will refund the full amount to you.
Withdrawals during the Course
<br/>
<br/>
If you don’t see the tremendous value you expected in our product, and you wish to withdraw within the first 2 Classes, we will proceed with a 100% refund – no questions asked.
However, once you have attended more than 2 days of the course, you will not be eligible for any refund.
No Admission transfer from one learner to the other
<br/>
<br/>Transfers to another batch
<br/>
<br/>
You are free to change your batch at any point of time before the commencement of the course, at no extra charge.
If for any reason you are unable to continue or complete the course, we would be happy to accommodate you in a different batch of the same course, at no additional cost.
<br/>
<br/>POLICY B
<br/>
<br/>
Policy B applies to all Self-Paced Programs (E-Learning Programs) of Mission1Success. Cancellations would be permitted as per –
uxmtc_1536_Screenshot20240105005411
If you wish to extend access to an e-learning program by a month, please write to us at helpmission1success@gmail.com and we will be happy to extend the program for a maximum period of one month. For extension beyond a month, you would need to pay 50% of the course price.
<br/>
<br/>NOTE:
<br/>
<br/>
All cancellation, rescheduling and substitution requests must be notified to us by email at helpmission1success@gmail.com
You are not eligible for refunds, if you have accessed and downloaded the course material.<br/>
<br/>
All refunds will be credited back to your account within 10-15 business days of the refund request.
Refunds or credits for rescheduling the training cannot be issued for non-attendance.<br/>
<br/>
Mission1Success may modify its refund policy at any time without notice, provided however that the refund policy in effect at the time of any transaction shall apply to such purchase despite any subsequent change in such policy.<br/>
<br/>
If you do not notify in writing about your cancellation or reschedule, or do not attend the training, you would not be offered a refund, nor the option to reschedule.<br/>
<br/>
Cancellations or rescheduling by Digital Nest
<br/>
<br/>
Mission1Success reserves the right to cancel or reschedule a course at any time, including but not limited to, insufficient registrations, trainer unavailability, or if the trainer could not attend due to unforeseen circumstances.<br/>
<br/>
Mission1Success not liable for any direct, indirect, consequential, or special damages that may be incurred due to a cancellation of a scheduled class.
  </p>
</div>;
};

export default Cancelation;
